import React, { useEffect, useState } from 'react'

import BalanceAndBudgetHeader from '../components/BalanceAndBudgetHeader'
import { PlanYearPicker } from '../components/PlanYearPicker/PlanYearPicker'
import TransactionsCard from '../components/TransactionsCard/TransactionsCard'
import { UnrecoverableErrorBanner } from '../components/UnrecoverableErrorBanner'

interface MemberTransactionsPageProps {
  planYear?: number
  planYears: number[]
}

const MemberTransactionsPageImpl: React.FC<MemberTransactionsPageProps> = ({ planYear, planYears }) => {
  // Fallback to the current plan year if there isn't one passed in
  let initialPlanYear = planYear || new Date().getFullYear()

  if (!planYears.includes(initialPlanYear)) {
    // If initial plan year is not found, try to grab the one from planYears if exists
    initialPlanYear = planYears.length > 0 ? Math.max(...planYears) : 0
  }
  const [selectedPlanYear, setSelectedPlanYear] = useState<number>(initialPlanYear)

  if (planYears.length === 0) {
    return (
      <div className='flex flex-col w-full gap-6'>
        <UnrecoverableErrorBanner />
      </div>
    )
  }

  const handlePlanYearChange = (year: number) => {
    setSelectedPlanYear(year)
  }

  // Sync selectedPlanYear changes back to URL
  useEffect(() => {
    if (selectedPlanYear) {
      const urlParams = new URLSearchParams(window.location.search)
      urlParams.set('plan_year', selectedPlanYear.toString())

      // Update URL without causing a page reload
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`
      window.history.replaceState({}, '', newUrl)
    }
  }, [selectedPlanYear])

  return (
    <div className='flex flex-col w-full gap-6'>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-row flex-wrap gap-3 w-full justify-between items-center'>
          <h1 className='heading-lg text-main'>Transactions</h1>
          {/*
            * The fixed height here is a trick to prevent the buttons from
            * increasing the height of the header's content box. This prevents
            * the page heading from jumping when navigating to and from pages
            * that don't have buttons in their header.
            */}
          <div className='flex flex-row items-center md:h-8'>
            <PlanYearPicker
              planYears={planYears}
              selectedPlanYear={selectedPlanYear}
              onPlanYearChange={handlePlanYearChange}
            />
          </div>
        </div>
        <h4 className='text-gray-500'>
          Past purchases and activity using your balance
        </h4>
      </div>
      <BalanceAndBudgetHeader
        planYear={selectedPlanYear}
        isForTransactionsPage
      />
      <TransactionsCard planYear={selectedPlanYear} />
    </div>
  )
}

export const MemberTransactionsPage: React.FC<MemberTransactionsPageProps> = (props) => {
  return (
    <MemberTransactionsPageImpl {...props} />
  )
}

export default MemberTransactionsPage
